<template>
  <div>
    <el-card>
      <b-row>
        <b-col cols="auto" class="mr-auto">
          <h6>
            <span>{{ formData.visitDate }}</span>
            <el-divider direction="vertical"></el-divider>
            <span>{{ formData.scmName }}</span>
            <el-divider direction="vertical"></el-divider>
            <span class="table-text" v-html="formData.visitTitle"></span>
          </h6>
          <div>
            <span class="table-text">No：{{ formData.visitNo }}</span>
            <el-divider direction="vertical"></el-divider>
            <span class="table-text"
              >Create：{{ formData.createByName }} at
              {{ formData.createTime }}</span
            >
          </div>
        </b-col>
        <b-col cols="auto">
          <a v-b-toggle.collapse-main role="button" style="color: #606266">
            <i
              v-if="isShowMainPanel"
              class="fa fa-chevron-down"
              title="收起"
            ></i>
            <i v-else class="fa fa-chevron-up" title="展开"></i>
          </a>
        </b-col>
      </b-row>
      <b-collapse v-model="isShowMainPanel" id="collapse-main">
        <div class="mt-3">
          <span style="color: #007bff" class="table-text">{{
            formData.visitPerson
          }}</span>
          <el-divider direction="vertical"></el-divider>
          <span style="color: #444444" class="table-text mr-1">厂方人员：</span
          ><span style="color: #444444" class="table-text">{{
            formData.scmPerson
          }}</span>
          <div class="mt-2" v-if="formData.visitDescription">
            <p
              style="
                        font-size: 14px;
                        color: #606266;
                        white-space: pre-line;
                      "
              v-html="formData.visitDescription"
            ></p>
          </div>
        </div>
      </b-collapse>
    </el-card>
    <el-card>
      <b-row>
        <b-col cols="auto" class="mr-auto">
          <h6>拜访评分记录</h6>
        </b-col>
        <b-col cols="auto">
          <a v-b-toggle.collapse-rating role="button" style="color: #606266">
            <i
              v-if="isShowRatingPanel"
              class="fa fa-chevron-down"
              title="收起"
            ></i>
            <i v-else class="fa fa-chevron-up" title="展开"></i>
          </a>
        </b-col>
      </b-row>
      <b-collapse v-model="isShowRatingPanel" id="collapse-rating">
        <visit-score-table class="mt-2" :code="visitCode" />
      </b-collapse>
    </el-card>
    <el-card>
      <b-row>
        <b-col cols="auto" class="mr-auto">
          <h6>拜访照片信息</h6>
        </b-col>
        <b-col cols="auto">
          <a v-b-toggle.collapse-images role="button" style="color: #606266">
            <i
              v-if="isShowImagePanel"
              class="fa fa-chevron-down"
              title="收起"
            ></i>
            <i v-else class="fa fa-chevron-up" title="展开"></i>
          </a>
        </b-col>
      </b-row>
      <b-collapse v-model="isShowImagePanel" id="collapse-images">
        <visit-image-table
          class="mt-2"
          :scmCode="formData.scmCode"
          :visitCode="visitCode"
        />
      </b-collapse>
    </el-card>
  </div>
</template>
<script>
import VisitImageTable from './visit-image-table'
import VisitScoreTable from './visit-score-table'
export default {
  name: 'opview-visit-info',
  components: {
    VisitScoreTable,
    VisitImageTable
  },
  data() {
    return {
      formData: {},
      isShowMainPanel: false,
      isShowRatingPanel: true,
      isShowImagePanel: true
    }
  },
  computed: {
    visitCode() {
      return this.$route.params.code
    }
  },
  beforeCreate() {
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#f1f1f1;')
  },
  created() {
    this.loadData()
  },
  destroyed() {
    this.formData = {}
  },
  methods: {
    loadData() {
      if (!this.visitCode) return
      this.$api
        .opaScmVisitDetailApi({ visitCode: this.visitCode })
        .then((res) => {
          this.formData = res.body || {}
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.table-text {
  color: #606266;
  font-size: 14px;
}
.el-card {
  margin: 20px 10px;
}
</style>
